import { programBuilder } from '../../shared/builders/program.builder';

export function programDetailsBuilder(data) {
  return programBuilder(data);
}
